'use client';

import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { ChevronLeftIcon } from '@/icons';
import { useUser } from '@/lib/auth';
import { confirmDialog, IconButton } from '@/ui_v3';
import { usePreventNavigation } from '../../../hooks/usePreventNavigation';
import { useBuildFormContext } from '../form/schema';
export const RouteBackButton = () => {
  const router = useRouter();
  const {
    user
  } = useUser();
  const isGuest = !user;
  const {
    t
  } = useTranslation(['build']);
  const {
    formState: {
      isDirty
    }
  } = useBuildFormContext();

  // 페이지 이동 방지
  usePreventNavigation({
    when: isDirty && !isGuest,
    onNavigationAttempt: resumeNavigation => {
      void (async () => {
        const confirmed = await confirmDialog.openAsync({
          header: {
            title: t('build:build.leaveConfirm.title')
          },
          body: t('build:build.leaveConfirm.description'),
          confirmText: t('build:build.leaveConfirm.confirm')
        });
        if (confirmed) {
          logger.track('page_leave_confirm');
          resumeNavigation();
        } else {
          logger.track('page_leave_cancel');
        }
      })();
    },
    onRefreshAttempt: () => {
      logger.track('refresh_page');
    }
  });
  const handleBack = () => {
    if (window.history.length > 1) {
      router.back();
    } else {
      void router.push('/public');
    }
    logger.track('build_exit');
  };
  return <IconButton size="md" variant="outlined" intent="neutral" className="shrink-0" onClick={handleBack} data-sentry-element="IconButton" data-sentry-component="RouteBackButton" data-sentry-source-file="RouteBackButton.tsx">
      <ChevronLeftIcon size="md" data-sentry-element="ChevronLeftIcon" data-sentry-source-file="RouteBackButton.tsx" />
    </IconButton>;
};